module.exports = __webpack_public_path__ + "img/alcance.895c35d5.svg";